import React from 'react';
import { Button, Modal, Card, ContentCard, Status, Chip } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import Style from './widgetRow.module.css';

export function mappingColorStatus(status) {
    const mappingColors = {
        published: 'green',
        draft: 'orange',
        closed: 'red',
        over: 'red',
        unpublished: 'red'
    };
    return mappingColors[status] || 'red';
}

const EventRow = ({ event, context }) => {
    const { t } = useTranslation();
    let dateObject = new Date(event.start_date);
    // use padStart to display 2 number if day/month contain only one (ex: 1/1/2021 => 01/01/2021)
    const start_date = [String(dateObject.getDate()).padStart(2, '0'), String(dateObject.getMonth() + 1).padStart(2, '0'), dateObject.getFullYear()].join('/');
    const start_hour = [String(dateObject.getHours()).padStart(2, '0'), String(dateObject.getMinutes()).padStart(2, '0')].join(':');
    const color = ['published', 'draft'].includes(event.status) ? mappingColorStatus(event.status) : 'red';
    const text = event.status === 'published' ? t('eventStatus.published') : event.status === 'draft' ? t('eventStatus.draft') : t('ticket.common.closed');
    return (
        <>
            <Card>
                <ContentCard className={Style['event_line']}>
                    <div>
                        <div className={Style['event_name']}>{event.name}</div>
                        <div className={Style['event_date']}>
                            {start_date} {start_hour} • E{event.id}
                        </div>
                    </div>
                    <Chip primary text={context === 'personal_space' ? t('ticket.personal_spaces.list.title') : t('ticket.widgets.event.widget_default_name')} />
                    <div> </div>
                    <div className={Style['event_status']}>
                        <Status style={{ border: `1px solid ${color}` }} className={Style['event_status_content']} text={text} color={color} responsive />
                    </div>
                </ContentCard>
            </Card>
        </>
    );
};

const eventListModal = ({ widget, showList, setDisplayList, context }) => {
    const { t } = useTranslation();

    const withNoEvents = React.useMemo(() => {
        return (!widget.events || !widget.events.length) && !widget.event && !widget.all_events;
    }, [widget.events, widget.event, widget]);

    return (
        <>
            {showList && (
                <Modal
                    size={withNoEvents || widget.all_events ? 'mini' : 'extralarge'}
                    open={showList}
                    title={t('ticket.widgets.event_list_modal.title')}
                    subtitle={t('ticket.widgets.event_list_modal.subtitle')}
                    onClose={() => setDisplayList(false)}
                    cancelButton={<Button onClick={() => setDisplayList(false)} label={t('ticket.common.action.back')} />}
                >
                    <div>
                        {withNoEvents && <span>{t('ticket.widgets.event_list_modal.no_events')}</span>}
                        {widget.all_events && <span>{t('ticket.widgets.event_list_modal.all_events')}</span>}
                        {widget.events?.map((event, index) => {
                            return <EventRow event={event} key={index} context={context} />;
                        })}
                        {widget.event && <EventRow event={widget.event} context={context} />}
                    </div>
                </Modal>
            )}
        </>
    );
};

export default eventListModal;
